module.exports = __webpack_public_path__ + "img/palm-trees.4f13aa96.jpg";